import React, {useEffect} from 'react';
import {
    Grid,
    Header,
    Button,
    Input,
    Form,
    Segment,
} from 'semantic-ui-react';
import {Formik} from 'formik';
import {useNavigate} from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css';
import {useAuthStore} from "../stores/useAuthStore";
import ErrorMsg from "./ErrorMsg";

const Login = () => {
    const navigate = useNavigate();
    const loginUser = useAuthStore(state => state.loginUser);
    const ucdId = useAuthStore(state => state.ucdId);

    const handleFormSubmit = async (values) => {
        console.log('Submitting form with values:', values);
        const result = await loginUser(values);
        console.log('Auth result:', result);

        try {
            if (result.success) {
                navigate('/dashboard');
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        let params = new URLSearchParams(window.location.search);
        let ucdId = params.get('ucdId') ?? '';
        let password = params.get('password') ?? '';

        if(ucdId.length > 0 && password.length > 0){
            handleFormSubmit({ucdId: ucdId, password:password});
            // Clear URL parameters
            window.history.replaceState({}, '', window.location.pathname);
        }
    }, []);

    useEffect(() => {
        if(ucdId.length > 0) {
            console.log('redirecting...');
            navigate('/dashboard');
        }
    },[ucdId])

    return (
        <Grid
            textAlign='center'
            style={{height: '100vh', backgroundColor: '#d7dbde'}}
            verticalAlign='middle'
        >
            <Grid.Column style={{maxWidth: 450}}>
                <img
                    src={'https://ucdir.com/wp-content/uploads/2024/02/UCD_Logo350px.png'}
                    style={{width: '100%'}}
                    alt="Logo"
                />
                <Header as='h5' textAlign='center' style={{margin: 0}}>
                    Please enter your church code number and password here. <br/>
                    If you do not have them, please contact your church directly.
                </Header>
                <ErrorMsg/>
                <Segment stacked>
                    <Formik
                        initialValues={{
                            ucdId: '',
                            password: '',
                        }}
                        onSubmit={handleFormSubmit}
                    >
                        {({handleChange, handleBlur, handleSubmit, values}) => (
                            <Form onSubmit={handleSubmit}>
                                <Form.Field>
                                    <label>Church Code:</label>
                                    <Input
                                        type='text'
                                        name='ucdId'
                                        fluid
                                        icon='user'
                                        iconPosition='left'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.ucdId}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Church Password:</label>
                                    <Input
                                        type='password'
                                        name='password'
                                        fluid
                                        icon='lock'
                                        iconPosition='left'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.password}
                                    />
                                </Form.Field>
                                <Button type='submit' className='normal-button'>
                                    Log In
                                </Button>
                            </Form>
                        )}
                    </Formik>
                </Segment>
            </Grid.Column>
        </Grid>
    );
};

export default Login;